module.exports = __webpack_public_path__ + "img/assetSingleChengguoBanner.649612c.png";